module.exports = __webpack_public_path__ + "static/media/icon-right.b958e204.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-right.svg
// module id = 181
// module chunks = 0